'use server';

import { SessionService } from '@/contexts/authentication';
import type { SavedMaze } from '../types';

export interface ListSavedMazesResult {
  mazes: SavedMaze[];
  total: number;
  hasMore: boolean;
}

export async function listSavedMazes(params?: {
  page?: number;
  pageSize?: number;
}): Promise<ListSavedMazesResult> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { mazes: [], total: 0, hasMore: false };

  const page = params?.page ?? 1;
  const pageSize = params?.pageSize ?? 20;
  const offset = (page - 1) * pageSize;

  const { getSavedMazeRepository } = await import('../repositories');
  const repo = getSavedMazeRepository();

  try {
    const result = await repo.listByFamily({
      familyId,
      limit: pageSize,
      offset,
    });

    return {
      mazes: result.mazes,
      total: result.total,
      hasMore: offset + pageSize < result.total,
    };
  } catch {
    // Table may not exist yet (migration not run)
    return { mazes: [], total: 0, hasMore: false };
  }
}
